/* eslint-disable import/prefer-default-export */
import type { TBlogHeroSlideBackgroundColor } from '../types';

export const accentColorShouldBeLemon = (backgroundColor: TBlogHeroSlideBackgroundColor) => ['cedar', 'charcoal', 'poppy', 'storm'].includes(backgroundColor);
